import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Row, Spinner } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { addModifierSchemas } from "components/Common/validation"
import { useDispatch } from "react-redux"
import Switch from "components/Shared/Switch"
import {
  addModifierGroups,
  getModifierGroupDetails,
  updateModifierGroups,
} from "store/actions/modifierGroupAction"
import { useSelector } from "react-redux"
import Spinners from "components/Shared/Spinners"
import SweatAlert from "components/Shared/SweatAlert"
import { showAlert } from "store/reducers/alertReducer"
import { getItemsListDropdown } from "store/actions/itemsAction"
import { Dropdown } from "primereact/dropdown"
import BackButton from "components/Shared/BackButton"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  getImagePreviewSrc,
  handleFileChange,
} from "components/Shared/fileHandlers"
import Select from "react-select"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"
import {
  modifierGroupHeight,
  modifierGroupSize,
  modifierGroupWidth,
} from "components/Common/ImageSize"
import TextError from "components/Shared/TextError"

const initialValues = {
  nameAr: "",
  nameEn: "",
  displayOrder: null,
  // label: "",
  minimum: "",
  maximum: "",
  maxModifiersOptions: "0",
  freeModifiersCount: "0",
  type: "",
  // enabled: true,
  imageType: "UPLOAD",
  imageUrl: "",
  imageFile: null,
  item: null,
  countryCode: null,
  hasSingleQtyModifierSelection:true,
}
const AddModifierGroup = ({ mode, editActionType }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${
    mode === "add" || mode === "allModifierAdd" ? t("Add") : t("Edit")
  } ${t("Modifier | Sign Burger")}`

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { categoryId, itemId } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const {
    loading,
    error,
    message,
    isLoading,
    actionType,
    modifierGroupDetails,
  } = useSelector(state => state.ModifierGroups)
  const { itemsListDropdown } = useSelector(state => state.Items)
  const { countryList } = useSelector(state => state.Countries)
  const { isImageCompressing } = useSelector(state => state.Common)

  useEffect(() => {
    if (mode === "edit") {
      getOldValues()
    }
  }, [])

  // CALLED ITEMS LIST IF HAVE allModifierAdd
  useEffect(() => {
    // if (mode === "allModifierAdd") {
    //   fetchItemList()
    // }
    fetchCountryList()
  }, [])

  const fetchItemList = countryCode => {
    const payload = {
      category: [],
      countryCode,
    }
    dispatch(getItemsListDropdown(payload))
  }

  useEffect(() => {
    if (mode === "add") {
      setFormValues({
        ...formValues,
        item: itemId,
      })
    }
  }, [])

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  useEffect(() => {
    if (modifierGroupDetails && !loading && mode === "edit") {
      const {
        _id,
        modifierType,
        name,
        nameAr,
        imageUrlType,
        imageUrl,
        displayOrder,
        type,
        minimum,
        maximum,
        maxModifiersOptions,
        freeModifiersCount,
        modifiers,
        status,
        countryCode,
        hasSingleQtyModifierSelection
      } = modifierGroupDetails

      // fetchItemList(countryCode)

      const matchedCountry = countryList.find(
        item => item.countryCode === countryCode
      )
      var updatedCountryCode = null
      if (matchedCountry) {
        const { name, countryCode } = matchedCountry
        updatedCountryCode = { label: name, value: countryCode }
      }

      setFormValues({
        ...formValues,
        nameAr,
        nameEn: name,
        displayOrder,
        minimum,
        maximum,
        maxModifiersOptions,
        freeModifiersCount,
        type,
        // enabled: status === 1 ? true : false,
        imageType: imageUrlType,
        imageUrl: imageUrl,
        item: _id,
        countryCode: updatedCountryCode,
        hasSingleQtyModifierSelection: hasSingleQtyModifierSelection ?? true
      })
    }
  }, [modifierGroupDetails, countryList])

  const getOldValues = () => {
    const payload = {
      id,
    }

    dispatch(getModifierGroupDetails(payload))
  }
  // console.log(editActionType, mode)
  const [formValues, setFormValues] = useState(initialValues)
  const handleSubmit = values => {
    const {
      nameAr,
      nameEn,
      displayOrder,
      // label,
      minimum,
      maximum,
      type,
      // enabled,
      imageType,
      imageUrl,
      imageFile,
      maxModifiersOptions,
      freeModifiersCount,
      item,
      countryCode,
      hasSingleQtyModifierSelection
    } = values

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("modifierType", "modifier-group")
    data.append("type", type)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("minimum", minimum)
    data.append("maximum", maximum)
    // data.append("maxModifiersOptions", maxModifiersOptions)
    // data.append("freeModifiersCount", freeModifiersCount)
    data.append("image", imageFile)
    data.append("countryCode", countryCode?.value?.toUpperCase())
    data.append("hasSingleQtyModifierSelection", hasSingleQtyModifierSelection)
    if (mode === "add") {
      data.append("item", itemId)
      dispatch(addModifierGroups(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            // navigate(
            //   `/menus/categories/${categoryId}/items/${itemId}/modifiers`
            // )
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      data.append("id", id)
      dispatch(updateModifierGroups(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            if (editActionType === "modifierEdit") {
              // navigate(
              //   `/menus/categories/${categoryId}/items/${itemId}/modifiers`
              // )
              navigate(-1)
            } else {
              // navigate(`/menus/modifier-groups`)
              navigate(-1)
            }
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "allModifierAdd") {
      data.append("item", item)
      dispatch(addModifierGroups(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            navigate(-1)
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  if (loading && mode === "edit") return <Spinners />

  return (
    <div className="page-content modifiers_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Card>
            <CardBody>
              <CardTitle className="d-flex align-items-center">
                <BackButton />
                {mode === "add" || mode === "allModifierAdd"
                  ? t("Add")
                  : t("Edit")}{" "}
                {t("Modifier Group")}
              </CardTitle>
              <Formik
                enableReinitialize={true}
                initialValues={formValues}
                onSubmit={handleSubmit}
                validationSchema={addModifierSchemas(mode)}
              >
                {({ errors, touched, values, isSubmitting, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="nameEn">
                            {" "}
                            <span className="text-danger">*</span>{" "}
                            {t("Name(English)")}
                          </label>
                          <Field
                            type="text"
                            id="nameEn"
                            name="nameEn"
                            placeholder={t("Name(English)")}
                            className={`form-control ${
                              touched.nameEn && errors.nameEn
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="nameEn" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="nameAr">
                            {" "}
                            <span className="text-danger">*</span>{" "}
                            {t("Name(عربي)")}
                          </label>
                          <Field
                            type="text"
                            style={{ direction: "rtl" }}
                            id="nameAr"
                            name="nameAr"
                            placeholder={t("Name(عربي)")}
                            className={`form-control ${
                              touched.nameAr && errors.nameAr
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="nameAr" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="displayOrder">
                            {" "}
                            <span className="text-danger">*</span>{" "}
                            {t("Display Order")}
                          </label>
                          <Field
                            type="text"
                            id="displayOrder"
                            name="displayOrder"
                            placeholder={t("Display Order")}
                            className={`form-control ${
                              touched.displayOrder && errors.displayOrder
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="displayOrder" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="minimum">
                            <span className="text-danger">*</span>{" "}
                            {t("Minimum")}
                          </label>
                          <Field
                            type="text"
                            id="minimum"
                            name="minimum"
                            placeholder="e.g. 1"
                            className={`form-control ${
                              touched.minimum && errors.minimum
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="minimum" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="maximum">
                            <span className="text-danger">*</span>{" "}
                            {t("Maximum")}
                          </label>
                          <Field
                            type="text"
                            id="maximum"
                            name="maximum"
                            placeholder="e.g. 1"
                            className={`form-control ${
                              touched.maximum && errors.maximum
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="maximum" />
                        </div>
                      </div>

                      {/* <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="maxModifiersOptions">
                            Max Modifiers Options
                          </label>
                          <Field
                            type="text"
                            id="maxModifiersOptions"
                            name="maxModifiersOptions"
                            placeholder="Max Modifiers Options"
                            className={`form-control ${
                              touched.maxModifiersOptions &&
                              errors.maxModifiersOptions
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError
                            name="maxModifiersOptions"
                            
                          />
                        </div>
                      </div> */}

                      {/* <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="freeModifiersCount">
                            Free Modifiers Count
                          </label>
                          <Field
                            type="text"
                            id="freeModifiersCount"
                            name="freeModifiersCount"
                            placeholder="Free Modifiers Count"
                            className={`form-control ${
                              touched.freeModifiersCount &&
                              errors.freeModifiersCount
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError
                            name="freeModifiersCount"
                            
                          />
                        </div>
                      </div> */}

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="type">
                            {" "}
                            <span className="text-danger">*</span> {t("Type")}
                          </label>
                          <Field
                            as="select"
                            id="type"
                            name="type"
                            className={`form-control ${
                              touched.type && errors.type ? "is-invalid" : ""
                            }`}
                          >
                            <option hidden>{t("Select Type")}</option>
                            <option value="options">{t("Options")}</option>
                            {/* <option value="sizes">{t("Sizes")}</option> */}
                            {/* <option value="fries">Fries</option>
                            <option value="drinks">Drinks</option> */}
                          </Field>
                          <TextError name="type" />
                        </div>
                        {values.type === "sizes" && (
                          <span className="text-warning">
                            {t(
                              "Warning: Size modifiers override the product price."
                            )}
                          </span>
                        )}
                      </div>

                      <div className="col-lg-6">
                        <div className="mt-2">
                          <label htmlFor="countryCode">
                            <span className="text-danger">*</span>{" "}
                            {t("Select Country")}
                          </label>
                          <Select
                            value={values.countryCode}
                            onChange={selectedValue => {
                              setFieldValue("countryCode", selectedValue)
                              fetchItemList(selectedValue.value)
                              if (mode === "allModifierAdd")
                                setFieldValue("item", "")
                            }}
                            options={countryList?.map(item => ({
                              label:
                                language === "sa" ? item.nameAr : item.name,
                              value: item.countryCode,
                            }))}
                            placeholder={t("Select Country")}
                            className={`select2-selection ${
                              touched.countryCode && errors.countryCode
                                ? "danger_color_border"
                                : ""
                            } `}
                          />
                          <TextError name="countryCode" />
                        </div>
                      </div>

                      {mode === "allModifierAdd" && (
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="item">
                              <span className="text-danger ">*</span>{" "}
                              {t("Select Item")}
                            </label>
                            <Dropdown
                              value={values.item}
                              onChange={e => setFieldValue("item", e.value)}
                              options={itemsListDropdown?.map(item => ({
                                name: item.name,
                                value: item._id,
                              }))}
                              optionLabel="name"
                              placeholder={t("Select Item")}
                              filter
                              className={`w-full w-100 ${
                                touched.item && errors.item
                                  ? "danger_color_border"
                                  : ""
                              }`}
                            />
                            <TextError name="item" />
                          </div>
                        </div>
                      )}

                      {/* <div className="col-lg-3">
                        <div className="form_field">
                          <label htmlFor="enabled">Enabled</label>
                          <Switch
                            isChecked={values.enabled}
                            onClickHandler={() => {
                              setFieldValue("enabled", !values.enabled)
                            }}
                          />
                        </div>
                      </div> */}

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="imageType">
                            <span className="text-danger">*</span>{" "}
                            {t("Image Type")}
                          </label>
                          <Field
                            as="select"
                            id="imageType"
                            name="imageType"
                            className={`form-control ${
                              touched.imageType && errors.imageType
                                ? "is-invalid"
                                : ""
                            }`}
                            onChange={e => {
                              const selectedValue = e.target.value
                              setFieldValue("imageType", selectedValue)
                              // Reset the value of imageUrl and imageFile when the image type changes
                              setFieldValue("imageUrl", "")
                              setFieldValue("imageFile", null)
                            }}
                          >
                            <option value="URL">{t("Image Url")}</option>
                            <option value="UPLOAD">{t("Upload Image")}</option>
                          </Field>
                          <TextError name="imageType" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form_field">
                          {/* IMAGE URL */}
                          {values.imageType === "URL" && (
                            <div className="form_field">
                              <label htmlFor="imageUrl">
                                <span className="text-danger">*</span>{" "}
                                {t("URL")}
                              </label>
                              <Field
                                type="text"
                                id="imageUrl"
                                name="imageUrl"
                                className={`form-control ${
                                  touched.imageUrl && errors.imageUrl
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <TextError
                                name="imageUrl"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          )}
                          {/* UPLOAD IMAGE */}
                          {values.imageType === "UPLOAD" && (
                            <div className="form_field position-relative">
                              <label htmlFor="imageFile">
                                {" "}
                                <span className="text-danger">*</span>{" "}
                                {t("Upload Image")}
                              </label>
                              <input
                                type="file"
                                id="imageFile"
                                name="imageFile"
                                accept="image/jpeg, image/jpg, image/png"
                                className={`form-control ${
                                  touched.imageFile && errors.imageFile
                                    ? "is-invalid"
                                    : ""
                                }`}
                                onChange={e => {
                                  handleFileChange(
                                    e,
                                    "imageFile",
                                    setFieldValue,
                                    modifierGroupWidth,
                                    modifierGroupHeight,
                                    modifierGroupSize
                                  )
                                }}
                              />

                              {isImageCompressing && (
                                <Spinner
                                  color="primary"
                                  className="file_upload_btn"
                                />
                              )}
                              <TextError
                                name="imageFile"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          )}
                          {(() => {
                            const updatedMode =
                              mode === "add" || mode === "allModifierAdd"
                                ? "add"
                                : mode
                            return (
                              getImagePreviewSrc(updatedMode, values) && (
                                <div className="mt-3">
                                  <img
                                    src={getImagePreviewSrc(
                                      updatedMode,
                                      values
                                    )}
                                    alt="Preview"
                                    className="img_preview"
                                  />
                                </div>
                              )
                            )
                          })()}

                          <span>
                            {t(
                              "Recommended dimensions: Square Image and Size should be less than or equal to {{size}} KB",
                              {
                                width: modifierGroupWidth,
                                height: modifierGroupHeight,
                                size: modifierGroupSize,
                              }
                            )}
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-12">
                        <span>Recommended size: 103 x 103</span>
                      </div> */}
                      
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="hasSingleQtyModifierSelection">
                            {t("Do Not Allow Multiple Quantity")}
                          </label>

                          <Switch
                            onClickHandler={e => {
                              setFieldValue(
                                "hasSingleQtyModifierSelection",
                                !values.hasSingleQtyModifierSelection
                              )
                            }}
                            isChecked={values.hasSingleQtyModifierSelection}
                          />
                          <TextError name="hasSingleQtyModifierSelection" />
                        </div>
                      </div>
                        

                      <div className="mt-3"></div>
                      <div className="col-12 d-flex justify-content-end my-3">
                        <Button
                          type="button"
                          className="mx-2"
                          color="secondary"
                          onClick={() => navigate(-1)}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          type="submit"
                          color="success"
                          className="w_fit_content"
                          disabled={isLoading || isImageCompressing}
                        >
                          {mode === "add" || mode === "allModifierAdd"
                            ? t("Add")
                            : null}
                          {mode === "edit" && t("Save")}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Row>
      </div>
    </div>
  )
}

export default AddModifierGroup
